'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const utils_fromEntries = require('./fromEntries.cjs.js');

const omit = (obj, keys) => {
  return utils_fromEntries.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
};

exports.omit = omit;
//# sourceMappingURL=omit.cjs.js.map
